import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IEventBlock, IEventParam } from "../../../interfaces";
import { SpecialCompbaser } from "../../../components/compbaser";
import { CommonService, ContainerService, LocalStoreService, StoreSelectorsService } from "../../../services";
import { LargePageSizeOptions } from "../../../common";
import { actionCRUDRecord, actionRemoveEventParam, actionSelectedSceneItemId } from "../../../store/actions/user.actions";
import { SelectionChange, SelectionModel } from "@angular/cdk/collections";
import { DialogPopComponent } from "../../../components/dialog-pop/dialog-pop.component";
import { Subject } from "rxjs";
import { Lib } from "../../../../libs/Lib";
import * as _ from "lodash";

@Component({
    selector: 'app-events-explorer',
    templateUrl: './events-explorer.component.html',
    styleUrls: ['./events-explorer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsExplorerComponent extends SpecialCompbaser implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    readonly pageSizeOptions = LargePageSizeOptions;
    pageSize = 10;
    pageIndex = 0;

    globalFilter = '';
    columnFilter = {
        eventName: ''
    };
    eventSelected;
    selectedEventName = '';
    toggleIcon = true;
    dataSource: MatTableDataSource<IEventBlock>;
    displayedColumns: string[] = ['select', 'icon', 'eventName', 'eventType', 'sceneName', 'eventSceneId', 'blockName']; // 'jump' ,
    allowMultiSelect = false;
    selection: SelectionModel<IEventBlock>;
    eventBlocks: IEventBlock[] = [];
    eventParams: Array<IEventParam> = [];
    eventStrings: Array<string> = [];

    @Input() selectedEvent: IEventBlock;
    @Output() selectedModal: EventEmitter<Subject<SelectionChange<IEventBlock>>> = new EventEmitter();

    constructor(
        private storeSelector: StoreSelectorsService,
        private containerService: ContainerService,
        private commonService: CommonService,
        private localStoreService: LocalStoreService,
        private router: Router,
        public override dialog: MatDialog,
        private route: ActivatedRoute,
        public cd: ChangeDetectorRef
    ) {
        super();
        const initialSelection = [];
        this.selection = new SelectionModel<IEventBlock>(this.allowMultiSelect, initialSelection);
        this.pageSize = parseInt(this.localStoreService.getStorageValConfig('pageSize')) || 10;
    }

    ngOnInit(): void {
        if (this.selectedEvent) {
            this.columnFilter['eventSceneId'] = this.selectedEvent.eventSceneId;
            this.columnFilter['eventBlockId'] = this.selectedEvent.eventBlockId;
        }
        this.cod(
            this.route.queryParams.subscribe(params => {
                if (params && params['filter']) {
                    try {
                        setTimeout(() => {
                            this.globalFilter = Lib.Base64().decode(params['filter']);
                            this.applyFilter(this.globalFilter);
                            this.cd.markForCheck();
                        }, 333);
                    } catch (e) {
                    }
                }
            })
        );
        this.cod(
            this.storeSelector.getAllEventsInSystemStructured()
                .subscribe((data) => {
                    this.eventStrings = data.eventStrings;
                    this.eventBlocks = data.eventBlocks;
                    this.eventParams = data.eventParams;
                    this.initTable();
                })
        );
        this.selectedModal.emit(this.selection.changed);
    }

    initTable() {
        this.dataSource = new MatTableDataSource(this.eventBlocks);
        this.dataSource.sortingDataAccessor = (item, property) => {
            return item[property];
        };
        this.dataSource.filterPredicate = this.customFilterPredicate();
        setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.updateFilter();
        });
    }

    clearSelection() {
        this.globalFilter = '';
        this.applyFilter('');
        this.selection.clear();
    }

    applyFilter(filterValue: string) {
        if (!this.dataSource) return;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    updateFilter(event = null) {
        this.globalFilter = '';
        if (event) {
            this.columnFilter = event;
        }
        if (this.dataSource) {
            this.clearSelection();
            this.dataSource.filter = JSON.stringify(this.columnFilter);
        }
    }

    filterByEventName(eventName) {
        this.columnFilter = {
            eventName
        };
        if (this.dataSource) this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    toggleVideoPane() {
        this.toggleIcon = !this.toggleIcon;
    }

    jumpToSceneItem(i_event: IEventBlock = null) {
        const event = i_event ? i_event : this.selection.selected[0];
        this.router.navigateByUrl(`/editor/list/${event.eventSceneId}`);
        setTimeout(() => {
            this.containerService.activeSceneItemIds.next([event.eventBlockId]);
            this.storeSelector.dispatch(actionSelectedSceneItemId({ id: event.eventBlockId }));
        }, 333);
    }

    /**
     * Delete event
     *  1. delete event in events list 
     *  2. delete event used in scenes
     */
    deleteEvent() {
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: { name: `are you sure you want to delete?`, showCancel: true }
        });
        dialogRef.afterClosed().subscribe(async (r) => {
            if (r) {
                const selectedEvent: IEventBlock = this.selection.selected[0];
                if (!selectedEvent) return;

                switch (selectedEvent.eventType) {
                    case 'param object':
                    case 'param list': {

                        // remove event params from events list
                        this.storeSelector.dispatch(actionCRUDRecord({
                            saveRecord: {
                                studioId: this.localStoreService.getStorageConfig().studioId,
                                command: 'delete',
                                primary: 'event_param_id',
                                table: 'event_params',
                                body: {},
                                id: [selectedEvent.eventBlockId]
                            }
                        }));
                        this.storeSelector.dispatch(actionRemoveEventParam({
                            eventParamId: selectedEvent.eventBlockId
                        }));

                        // remove event used in scenes
                        this.commonService.removeEventsUsedInScenes(selectedEvent.eventName);
                        break;
                    }
                    case 'EventCommand':
                    case 'EventCommands': {
                        // remove EventCommand from scene item
                        this.commonService.removeEventCommandsInScene(selectedEvent.eventSceneId, [selectedEvent.eventBlockId], selectedEvent.eventName, true);
                        break;
                    }
                    default: {
                        // remove EventName from scene Item
                        this.commonService.removeEventNameInSceneItem(selectedEvent, true);
                        break;
                    }
                }
            }
        });
    }

    private customFilterPredicate() {
        const myFilterPredicate = (data: any, filter: string): boolean => {
            let globalMatch = !this.globalFilter;

            if (this.globalFilter) {
                // search all fields
                globalMatch = JSON.stringify(data).toLowerCase().indexOf(this.globalFilter.trim().toLowerCase()) !== -1;
            }

            if (!globalMatch) {
                return false;
            }
            try {
                const filterObj = JSON.parse(filter);
                let isFilter = true;
                // tslint:disable-next-line:forin
                for (const col in filterObj) {
                    if (!filterObj[col]) continue;
                    const colData = data[col];

                    // if (typeof colData !== 'undefined' && colData.toString().toLowerCase() !== filterObj[col].trim().toLowerCase()) {
                    //     isFilter = false;
                    //     break;
                    // }

                    if (typeof colData !== 'undefined') {
                        const filterVal = filterObj[col].toString();
                        if (filterVal.startsWith('(NOT)')) {
                            isFilter = colData.toString().toLowerCase() != filterVal.slice(5).trim().toLowerCase();
                        } else {
                            isFilter = colData.toString().toLowerCase() == filterVal.trim().toLowerCase();
                        }
                        if (!isFilter) {
                            break;
                        }
                    }
                }
                return isFilter;
            } catch (e) {
                return true;
            }
        };
        return myFilterPredicate;
    }
}

// this.cod(
//     this.storeSelector.getAllEventsInSystem()
//         .subscribe((values) => {
//             const eventParams = values.eventParams;
//             this.eventBlocks = _.cloneDeep(values.eventBlocks);
//             this.eventStrings = [...new Set(this.eventBlocks.map((b) => b.eventName))];
//             eventParams.forEach((i_eventParam) => {
//                 this.eventBlocks.push({
//                         eventName: i_eventParam.event_name,
//                         eventType: isArray(i_eventParam?.event_value) ? 'param list' : 'param object',
//                         eventSceneId: 'none',
//                         eventBlockId: i_eventParam?.event_param_id,
//                         blockName: i_eventParam.event_name,
//                         sceneName: 'event database'
//                     }
//                 );
//             });
//             this.eventStrings = [...new Set(this.eventBlocks.map((b) => b.eventName))];
//             this.initTable();
//         })
// );
